import React, { RefObject, useEffect, useState } from 'react'

import { IMapSeat } from 'meta/map'
import { ICheckoutDetails } from 'meta/pages/checkout'
import { getUniqueTypeTicketsIds } from 'helpers/groups/unique'

import { Grid, GridContainer } from 'components/Layout/Grid'
import { useCheckoutDetails } from 'hooks/useCheckout'

import Group from './Group'
import Single from './Single'

interface IProps {
  modalRef?: RefObject<HTMLElement>
  onSelectSeat: (seats: Array<IMapSeat>, typeTicketId?: number) => void
}

const TicketSelection: React.FC<IProps> = (props) => {
  const { modalRef, onSelectSeat } = props

  const { eventTicket, initialTypeTicketId, initialGroupId } = useCheckoutDetails() as ICheckoutDetails
  const { data, groups } = eventTicket

  const [isSplitReady, setIsSplitReady] = useState<boolean>(false)
  const [areThereSingleTickets, setAreThereSingleTickets] = useState<boolean>(true)
  const [groupTicketIds, setGroupTicketIds] = useState<number[]>([])

  useEffect(() => {
    if (data && groups && groups.length > 0) {
      const uniqueGroupTicketIds = getUniqueTypeTicketsIds(groups)

      setGroupTicketIds(uniqueGroupTicketIds)
      setIsSplitReady(true)

      if (uniqueGroupTicketIds.length >= data.length) {
        setAreThereSingleTickets(false)
      }
    }

    if (groups && groups.length == 0) {
      setIsSplitReady(true)
    }
  }, [groups, data])

  return (
    <GridContainer>
      <Grid>
        {areThereSingleTickets && isSplitReady && (
          <Single
            modalRef={modalRef}
            onSelectSeat={onSelectSeat}
            ticketsData={data.filter((x) => !groupTicketIds.includes(x.id))}
          />
        )}

        {groups &&
          groups.length > 0 &&
          groups.map((elem, key) => {
            if (initialTypeTicketId && !elem.typeTicketIds.includes(initialTypeTicketId)) {
              return null
            }

            if (initialGroupId && elem.id !== initialGroupId) {
              return null
            }

            return <Group groupData={elem} key={key} />
          })}
      </Grid>
    </GridContainer>
  )
}

export default TicketSelection
